'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMouse = function IoMouse(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5z m9.6 12.6c0.2-0.1 0.2-0.1 0.3-0.1h0.1v13.8c0 2.8-1.6 5.5-4.1 7.1-0.4 0.2-0.7 0.4-1.1 0.5v0.1c-1.4 0.7-3.1 1-4.8 1-5.5 0-10-3.9-10-8.7v-13.8h0.1c0.1 0 0.2 0 0.4 0.1 2.6 1 5.9 1.8 9.5 1.8s6.9-0.8 9.5-1.8h0.1z m-4.8 21.3c0.4-0.1 0.7-0.3 1.1-0.5-0.4 0.2-0.7 0.3-1.1 0.5z m1.1-0.5c-0.4 0.2-0.7 0.3-1.1 0.5 0.4-0.2 0.7-0.3 1.1-0.5z m-5.6-33.4c5.4 0.2 9.7 4 9.7 8.8v1.7c-0.2 0.2-0.3 0.4-0.5 0.4 0 0.1-0.2 0-0.3 0.1-1.8 0.8-3.9 1.3-6.4 1.5h-0.2c-0.9 0-1.4 0-1.4-0.8v-6.7c0-0.7-0.5-1.2-1.2-1.2s-1.3 0.5-1.3 1.2v6.6c0 0.9-0.4 0.9-1.3 0.9h-0.1c-2.5-0.2-4.8-0.7-6.6-1.5-0.1 0-0.1-0.1-0.2-0.1-0.2 0-0.3-0.2-0.5-0.4v-1.7c0-4.8 4.5-8.7 9.9-8.8h0.4z' })
        )
    );
};

exports.default = IoMouse;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/mouse.js
// module id = 2842
// module chunks = 168707334958949